// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__KALIa","navbar":"footer_navbar__a3bW2","navitem":"footer_navitem__BDOE2"};